import styled from "styled-components";

export const SUP = styled.div`
position: fixed;
top: 0;
left: 0;
bottom: 0;
right: 0;
background-color: #000;
overflow-y: auto;

.form-wrap{
    
    display: flex;
    justify-content: center;
}
.form-head{
    display: flex;
    justify-content: center;
    margin: 25px 15px;
}
.form-head div{
    display: flex;
    justify-content: space-between;
    width: 400px;
}
.form-head div img{
    margin-top: 3px;
}
.form-head div h3{
    color: indigo;
    align-self: center;
}

.err{
    text-align: end;
    
}


input{
    width: 300px;
    margin: 0px;
    font-weight: 500;
    color: #2f4f42;
}
label{
    margin: 0px;
    font-weight: 500;
    color: #2f4f42;
}

 div{
    margin: 5px;
    position: relative;
}
 div .err{
    position: absolute;
    top: -3px;
    right: 0px;
}
.form-foot{
    margin: 25px 10px;
    display: flex;
    justify-content: center;
}
.btns button{
    width: 300px;
    align-self: center;
    font-weight: 500;
}
.btns{
    width: 680px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
}
.self{
    align-self: center;
    margin: 10px 10px;
    font-weight: 500;
}
.alert{
    width: 300px;
}
.al-wrap{
    display: flex;
    justify-content: center;
}
`